import { COLORS } from "ui-components/theme";
import { SECONDARY_COLOR, PRIMARY_COLOR, SPINNER_COLOR } from "utils/constants";

const color =
  SPINNER_COLOR || SECONDARY_COLOR || PRIMARY_COLOR || COLORS.blue[4];
const styles = {
  fullPage: {
    color: color,
    size: 150,
    backgroundColor: "white",
    position: "absolute",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    paddingTop: "35vh",
    justifyContent: "center"
  },
  modalContainer: {
    size: 100,
    color: color,
    width: "100%",
    height: "100%",
    alignItems: "center",
    justifyContent: "center"
  },
  button: {
    size: 19,
    width: "100%",
    height: "100%",
    color: COLORS.blue,
    alignItems: "center",
    justifyContent: "center"
  },
  inlineMessage: {
    size: 19,
    width: "100%",
    height: "100%",
    color: color,
    alignItems: "center",
    justifyContent: "center"
  }
};

export default styles;
